/**
 * Порядок и видимость блоков лендинга — задаются с сервера, без новой сборки.
 *
 * ⚠️ СЕРВЕР МОЖЕТ ПЕРЕСТАВИТЬ И СПРЯТАТЬ, НО НЕ ПРИДУМАТЬ. Сами блоки собраны в
 * приложении; настройка задаёт лишь порядок и показ. Подгружать содержимое
 * извне мы намеренно не делаем: приложение, тянущее себя с сервера, Apple
 * разбирает по правилам 2.5.2 и 4.7 — «исполняемый код извне». Нам лишние
 * поводы ни к чему.
 */
export type LandingBlockKey = 'hero' | 'credentials' | 'cases' | 'courses' | 'free' | 'numbers';

export type LandingBlockSetting = { key: string; visible?: boolean };

/**
 * Порядок по умолчанию — ровно тот, что был зашит в код.
 *
 * ⚠️ В ПРИЛОЖЕНИИ БЕСПЛАТНОЕ ВЫШЕ ВИТРИНЫ. Проверяющий магазина должен увидеть,
 * что попробовать можно без оплаты, раньше, чем список курсов: пустое или
 * «только за деньги» приложение — отказ по правилу 4.2.
 */
export const LANDING_BLOCKS: Record<'web' | 'app', LandingBlockKey[]> = {
  web: ['hero', 'credentials', 'cases', 'courses', 'free', 'numbers'],
  app: ['hero', 'free', 'credentials', 'cases', 'courses', 'numbers'],
};

const KNOWN = new Set<string>(LANDING_BLOCKS.web);

/**
 * Итоговый порядок блоков.
 *
 * ⚠️ ПУСТОЙ ЛЕНДИНГ НЕВОЗМОЖЕН НИ ПРИ КАКИХ НАСТРОЙКАХ. Это первый экран
 * приложения; если настройка не оставила ни одного знакомого блока, берётся
 * порядок из сборки. Иначе одна ошибка в админке превратила бы главную в
 * пустоту — и это увидели бы все разом, включая проверяющего.
 */
export function resolveLandingLayout(
  setting: LandingBlockSetting[] | undefined,
  isApp: boolean,
): LandingBlockKey[] {
  const fallback = isApp ? LANDING_BLOCKS.app : LANDING_BLOCKS.web;
  if (!Array.isArray(setting) || setting.length === 0) return fallback;

  const seen = new Set<string>();
  const out: LandingBlockKey[] = [];
  for (const item of setting) {
    const key = item?.key;
    // Незнакомый ключ пропускаем: настройка может оказаться новее приложения,
    // и старая сборка обязана это пережить.
    if (!key || !KNOWN.has(key) || seen.has(key)) continue;
    seen.add(key);
    if (item.visible === false) continue;
    out.push(key as LandingBlockKey);
  }
  return out.length > 0 ? out : fallback;
}
